import { render, staticRenderFns } from "./PointsInformation.vue?vue&type=template&id=41d2be80&scoped=true&"
import script from "./PointsInformation.vue?vue&type=script&lang=js&"
export * from "./PointsInformation.vue?vue&type=script&lang=js&"
import style0 from "./PointsInformation.vue?vue&type=style&index=0&id=41d2be80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d2be80",
  null
  
)

export default component.exports